/*
 Created by qing on 2021/1/23
 Des: 当前查看人
 */
import BaseItem from "../BaseItem"
import {
  DATA_TYPE__JSON, FORM_ITEM__CURRENT_VIEW_USER,
} from "../types"
import store from "../../store";
import Member from "./Member";

class CurrentViewUser extends BaseItem {
  constructor() {
    super()


    this.value = {
      depart: [], // 部门
      member: [], // 成员
      role: [],    // 角色
      external: [], // 外部联系人
      externalTag: [] // 外部联系人标签
    }
  }

  get title() {
    return this.fieldTitle || CurrentViewUser._title
  }

  set title(val) {
    this.fieldTitle = val
    this.temTitle = val
  }
}

CurrentViewUser._title = '当前查看人'
CurrentViewUser.type = FORM_ITEM__CURRENT_VIEW_USER
CurrentViewUser.use = true
CurrentViewUser.prototype.icon = 'iconfont icon-chengyuan'

CurrentViewUser.prototype.type = CurrentViewUser.type
CurrentViewUser.prototype.dataType = DATA_TYPE__JSON


CurrentViewUser.prototype.setValue = function (val) {

}
CurrentViewUser.prototype.filterOpts = [
  {
    name: '等于',
    method: 'eq'
  },
  {
    name: '不包含任意一个',
    method: 'nin'
  },
  {
    name: '包含任意一个',
    method: 'in'
  },
  {
    name: '同时包含',
    method: 'all'
  },
  {
    name: '为空',
    method: 'empty'
  },
  {
    name: '不为空',
    method: 'not_empty'
  },
]
CurrentViewUser.prototype.getValue = function () {
  return this.value
}
CurrentViewUser.prototype.setConf = function (opts) {
  this.setBase(opts)

  if (store.getters.userId) {
    // const members = store.state.userList.map(user => user.userId)
    if (store.getters.adminInfo.isMember) {
      this.value.member.push(store.getters.userId)
    } else {
      this.value.external.push(store.getters.userId)
    }
  }
}
CurrentViewUser.prototype.getConf = function () {
  const base = this.getBase()
  return {
    ...base,
  }
}
CurrentViewUser.prototype.valueToString = function (value, opt = {}) {


  const depList = store.getters.depListMap,
    roleList = store.getters.roleListMap,
    userList = store.getters.userListMap,
    extList = store.getters.extMap,
    labelList = store.getters.extLabelMap

  value = value || this.value
  if (!value.depart) value.depart = []
  if (!value.role) value.role = []
  if (!value.member) value.member = []
  if (!value.external) value.external = []
  if (!value.externalTag) value.externalTag = []
  return [
    ...value.depart.map(depId => depList[depId] ? depList[depId].depName : ''),
    ...value.role.map(roleId => roleList[roleId] ? roleList[roleId].roleName : ''),
    ...value.member.map(userId => userList[userId] ? userList[userId].nickname : ''),
    ...value.external.map(userId => extList[userId] ? extList[userId].orgUserName : ''),
    ...value.externalTag.map(labelId => labelList[labelId] ? labelList[labelId].labelName : '')
  ].filter(item => !!item).join('、')
}

export default CurrentViewUser
